import React, { Component } from 'react';
import phase1 from '../../../assets/images/svgs/roads/base_roads_phase1.svg';
import phase2 from '../../../assets/images/svgs/roads/base_roads_phase2.svg';
import phase3 from '../../../assets/images/svgs/roads/base_roads_phase3.svg';
import phase4 from '../../../assets/images/svgs/roads/base_roads_phase4.svg';
import phase5 from '../../../assets/images/svgs/roads/base_roads_phase5.svg';
import { CSSTransitionGroup } from 'react-transition-group';

/**
 * @class BackgroundRoads
 *
 * @description
 * Class for the background containers control, this group will
 * control visibility of the assets.
 *
 * @example
 * <BackgroundRoads />
 */
export default class BackgroundRoads extends Component {

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {Component} component
	 */
	render () {
		const { progress } = this.props;

		return (
			<CSSTransitionGroup
				className="fade"
				transitionName="fade"
				transitionEnterTimeout={800}
				transitionLeaveTimeout={800}>

				{
					progress <= 12 &&
					<img key={'phase1'} src={phase1} alt="passenger dock phase 1"/>
				}
				{
					(progress > 12 && progress <= 24) &&
					<img key={'phase2'} src={phase2} alt="passenger dock phase 2"/>
				}
				{
					(progress > 24 && progress <= 36) &&
					<img key={'phase3'} src={phase3} alt="passenger dock phase 3"/>
				}
				{
					(progress > 36 && progress <= 48) &&
					<img key={'phase4'} src={phase4} alt="passenger dock phase 4"/>
				}
				{
					progress > 48 &&
					<img key={'phase5'} src={phase5} alt="passenger dock phase 5"/>
				}

			</CSSTransitionGroup>
		);
	}
}
